import { navigate } from "gatsby";
import React, { MouseEvent, useEffect, useState } from "react";
import useAuthModal from "../../hooks/useAuthModal";
import useEventDetails from "../../hooks/useEventDetails";
import useSessionStore from "../../store/useSessionsStore";
import { AuthLink } from "../links";

interface ButtonDefaultProps {
  className?: string;
  signInRedirect?: string;
  signOutRedirect?: string;
  autoText?: boolean;
  closeNav?: () => void;
}

export default ({
  className,
  signInRedirect = "https://zerotrustsummit.upgather.com/2025/virtual/live",
  signOutRedirect = "/",
  autoText,
  closeNav
}: ButtonDefaultProps) => {
  const { registrationOnly, virtual } = useEventDetails();
  const { opened, openModal, user, signOut } = useAuthModal();
  const { sessionCount } = useSessionStore();

  const handleLogout = async (event: MouseEvent) => {
    event.preventDefault();
    if (registrationOnly && !opened) {
      openModal();
    }
    await signOut();
    navigate(virtual ? 'https://zerotrustsummit.upgather.com/2025/virtual' : signOutRedirect, {
      replace: true,
    });

    if (closeNav) {
      closeNav();
    }
  };

  useEffect(() => {
  }, [sessionCount]);

  return (
    <>
      {user ? (
        <a href="#" className={className} onClick={handleLogout}>
          {registrationOnly ? 'Register' : 'Logout'}
        </a>
      ) : (
        <AuthLink 
        to={virtual ? 'https://zerotrustsummit.upgather.com/2025/virtual/live' : signInRedirect}
        className={`button-container ${className}`}
        autoText={autoText}
        closeNav={closeNav}>
          <div className="register-button">
            {registrationOnly ? 'Register' : 'Login'}
          </div>
          {sessionCount > 0 && (
            <span className="counter">{sessionCount}</span>
          )}
        </AuthLink>
      )}
    </>
  );
};
